import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import i18n from "../../../i18next";
import MaterialIcon from 'material-icons-react';

import SectionTitle from './SectionTitle';
import ColoredIcon from './ColoredIcon';
import SearchButton from './SearchButton';

const CustomerInfoDetail = props => {

    const { rowStyle, colContainerStyle, relativeHeight, customerNameStyle, orderTimeText, darkGrayText, phoneText, emailText, test } = styles;
    const { customerName, customerEmail, customerPhone, firstOrderDate, lastOrderDate } = props.customerInsight;

    const renderCustomerInfo = () => {
        return (
            <Col style={{ padding: '0' }} sm={4} >
                <SectionTitle title={props.sectionTitle} />
                <div style={{ paddingLeft: '10px' }}>
                    <div style={customerNameStyle}>
                        {customerName}
                    </div>
                    <div style={orderTimeText}>
                        <div>
                            {i18n.t('screens:customerInsightScreen.firstOrder')} {firstOrderDate}
                        </div>
                        <div>
                            {i18n.t('screens:customerInsightScreen.lastOrder')} {lastOrderDate}
                        </div>
                        <div style={phoneText}>
                            {i18n.t('screens:customerInsightScreen.phoneNumber')}
                        </div>
                        <div style={darkGrayText}>
                            {customerPhone}
                        </div>
                        <div style={emailText}>
                            {i18n.t('screens:customerInsightScreen.email')}
                        </div>
                        <div style={darkGrayText}>
                            {customerEmail}
                        </div>

                    </div>
                </div>
            </Col>
        );
    }

    const renderAddressSection = () => {
        return (
            <Col sm={8}>
                {renderRedIcons()}
                {renderAddressGroup()}
                {renderViewAllButton()}
            </Col>
        );
    }

    const renderAddressGroup = () => {

        const { addressSection, addressHeader } = styles;
        const { customerAddresses } = props.customerInsight;

        return (
            <div style={addressSection}>
                <div style={addressHeader}>
                    {i18n.t('screens:customerInsightScreen.addresses')}
                </div>
                {renderAddresses(customerAddresses)}
            </div>
        );
    }

    const renderAddresses = addresses => {

        const { addressItem } = styles;

        if (addresses === null) {
            return null;
        }

        if (addresses.length > 4) {
            addresses = addresses.slice(0, 4);
        }

        return addresses.map(address => {
            return (
                <div style={addressItem}>
                    <MaterialIcon icon="room" size={14} color="color: 'rgb(128,128,128)'" /> {address}
                </div>
            );
        })
    }

    const renderViewAllButton = () => {
        return (
            <div style={{ padding: '5px 0 0 10px' }}>
                <SearchButton onClick={props.toggleAddressModal} search={false} positionTop={false} text={i18n.t('screens:customerInsightScreen.viewAll')} />
            </div>
        );
    }

    const renderRedIcons = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ColoredIcon icon="email" />
                <ColoredIcon icon="sms" />
                <ColoredIcon icon="percent" />
            </div>

        );
    }

    return (
        <Col sm={props.colSize} style={colContainerStyle}>
            <div style={relativeHeight}>
                <Row style={rowStyle}>
                    {renderCustomerInfo()}
                    {renderAddressSection()}
                </Row>
            </div>
        </Col>
    );
}

export default CustomerInfoDetail;

const styles = {
    rowStyle: {
        margin: '0'
    },
    colContainerStyle: {
        padding: '10px'
    },
    relativeHeight: {
        height: '170px',
        backgroundColor: 'white'
    },
    customerNameStyle: {
        fontSize: '16px',
        padding: '3px 0 0 0',
        fontWeight: 'bold'
    },
    orderTimeText: {
        fontSize: '12px',
        // color: 'rgb(196,196,196)',
        color: 'black'
    },
    darkGrayText: {
        // color: 'rgb(128,128,128)'
        color: 'black'
    },
    phoneText: {
        color: 'rgb(243,86,150)',
        fontWeight: 'bold'
    },
    emailText: {
        color: 'rgb(248,185,109)',
        fontWeight: 'bold'
    },
    addressSection: {
        height: '95px',
        fontSize: '14px',
        marginTop: '-5px'
    },
    addressHeader: {
        paddingLeft: '15px',
        color: 'rgb(3,134,208)',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    addressItem: {
        // color: 'rgb(128,128,128)',
        color: 'black',
        overflow: 'hidden',
        height: '20px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '12px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerInfoDetail.js